module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Corinne L. Saucier\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Dr. Corinne L. Saucier (1890-1960) dedicated her life to education and the preservation of the rich, local tradition of folklore in central and southern Louisiana. Her scholarly books include "), _c('B', [_c('I', [_vm._v("History of Avoyelles Parish, Traditions de la Paroisse des Avoyelles en Louisiane,")])], 1), _vm._v(" and "), _c('B', [_c('I', [_vm._v("Histoire et Geographie des Avoyelles en Louisiane.")])], 1), _vm._v(" She completed graduate studies at the Sorbonne in Paris and at Columbia University in New York, earning her doctorate in 1949 from Laval University in Quebec. Prior to her death in 1960, Saucier was professor of French and Spanish at Northwestern State College for twenty-four years and resided in Natchitoches, Louisiana, for twenty-nine years.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/wnRndb/tc-custom/9781455605798.jpg?1718183146979",
      "alt": "This image is the cover for the book History of Avoyelles Parish, Louisiana, Parish Histories"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("History of Avoyelles Parish, Louisiana, Parish Histories\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Originally published in 1943, this comprehensive volume chronicles the history of Avoyelles Parish, from the first Indian settlers to the time of the book's publication. Saucier provides in-depth information about the organization of the parish as it grew out of the Avoyelles Post during the French regime. Throughout the book, Saucier explores the many hardships endured by the first settlers, such as the health and sanitation, relief and welfare organizations, and numerous disasters-most notably the Red River flood of 1927. Saucier also provides the history of institutions, such as churches, education, banking, and journalism, that would serve as a foundation for its future population.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pelican publishing Company\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0